module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.jotFormID) ? _c('iframe', {
    style: (("\n    min-width: 100%;\n    height:" + _vm.iframeHeight + "px;\n    border:none;")),
    attrs: {
      "id": _vm.jotFormElementID,
      "allowtransparency": "true",
      "allowfullscreen": "true",
      "allow": "geolocation; microphone; camera",
      "src": ("https://form.jotform.com/" + _vm.jotFormID + "?" + _vm.prefillFields),
      "frameborder": "0",
      "scrolling": "no"
    }
  }) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29e0973f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29e0973f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/JotformEmbed.vue
// module id = 477
// module chunks = 3